import React, { useState, useEffect } from 'react';
import axios from 'axios';

function CommentForm({ postId, onCommentAdded }) {
  const [text, setText] = useState('');
  const [subscriberId, setSubscriberId] = useState(null);

  useEffect(() => {
    console.log('[CommentForm] 🔄 useEffect triggered');
  
    const checkSession = async () => {
      try {
        console.log('[CommentForm] 📡 Sending session check request...');
        const response = await axios.get(`${process.env.REACT_APP_API}/check/session`, {
          withCredentials: true,
        });
  
        console.log('[CommentForm] 🟢 Session check raw response:', response);
  
        if (response.data?.isAuthenticated && response.data.user) {
          setSubscriberId(response.data.user.id);
          console.log('[CommentForm] ✅ subscriberId set =>', response.data.user.id);
        } else {
          console.warn('[CommentForm] ⚠️ No authenticated user found in session');
        }
      } catch (error) {
        console.error('[CommentForm] ❌ Error checking session:', error);
      }
    };
  
    checkSession();
  }, []);
  

  // useEffect(() => {
  //   const checkSession = async () => {
  //     try {
  //       const response = await axios.get(`${process.env.REACT_APP_API}/check/session`, {
  //         withCredentials: true,
  //       });
  //       if (response.data.isAuthenticated && response.data.user) {
  //         setSubscriberId(response.data.user.id);
  //         console.log('[CommentForm] subscriberId =>', response.data.user.id);
  //       }
  //     } catch (error) {
  //       console.error('[CommentForm] Error checking session:', error);
  //     }
  //   };

  //   checkSession();
  // }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!text.trim() || !subscriberId) return;

    try {
      await axios.post(
        `${process.env.REACT_APP_API}/add/forum/comment`,
        { text, postId, subscriberId },
        { withCredentials: true }
      );
      setText('');
      onCommentAdded();
    } catch (error) {
      console.error('Error adding comment:', error);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ marginTop: '1rem' }}>
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Write a comment..."
        rows={3}
        style={{ width: '100%', padding: '0.5rem' }}
      />
      <button type="submit" style={{ marginTop: '0.5rem' }}>
        Submit Comment
      </button>
    </form>
  );
}

export default CommentForm;





// import React, { useState } from 'react';
// import axios from 'axios';

// function CommentForm({ postId, subscriberId, onCommentAdded }) {
//   const [text, setText] = useState('');

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!text.trim()) return;

//     try {
//       await axios.post(
//         `${process.env.REACT_APP_API}/add/forum/comment`,
//         { text, postId, subscriberId },
//         { withCredentials: true }
//       );
//       setText('');
//       onCommentAdded();
//     } catch (error) {
//       console.error('Error adding comment:', error);
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} style={{ marginTop: '1rem' }}>
//       <textarea
//         value={text}
//         onChange={(e) => setText(e.target.value)}
//         placeholder="Write a comment..."
//         rows={3}
//         style={{ width: '100%', padding: '0.5rem' }}
//       />
//       <button type="submit" style={{ marginTop: '0.5rem' }}>
//         Submit Comment
//       </button>
//     </form>
//   );
// }

// export default CommentForm;
